module.exports = __webpack_public_path__ + "img/icon-letter-l.a58a9608.svg";